import PropTypes from 'prop-types'
import { useEffectOnce } from 'react-use'
import { connect } from 'react-redux'
import { replace } from 'redux-little-router'
import { usePreviousAppState } from './PreviousAppStateManager'

const BaseRestorePreviousPath = ({ replace }) => {
  const { previousAppState, setPreviousAppState } = usePreviousAppState()

  useEffectOnce(() => {
    const { path, ...appState } = previousAppState
    if (path) {
      replace(path)
      setPreviousAppState(appState)
    }
  })

  return null
}

BaseRestorePreviousPath.propTypes = {
  replace: PropTypes.func.isRequired,
}

export const RestorePreviousPath = connect(
  null,
  { replace }
)(BaseRestorePreviousPath)
